const projectTaskStatuses = {
  not_started: { id: 'not_started', name: 'Not Started' },
  in_progress: { id: 'in_progress', name: 'In Progress' },
  completed: { id: 'completed', name: 'Completed' },
};

export default projectTaskStatuses;
